
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-interview-software",
      function () {
        return require("private-next-pages/video-interview-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-interview-software"])
      });
    }
  